export const SUBCOLLECTION_TODO = 'todo';
